import React from 'react';

const Live = () => (
  <svg
    width="61"
    height="24"
    viewBox="0 0 61 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="60.5" height="24" rx="12" fill="#D9F1E0" />
    <circle opacity="0.2" cx="15.75" cy="12" r="5.75" fill="#00A331" />
    <circle cx="15.7496" cy="12.0006" r="3.28571" fill="#00B7B1" />
    <path
      d="M26.6997 15V6.996H28.1037V13.764H31.6317V15H26.6997ZM32.8989 15V6.996H34.3029V15H32.8989ZM38.3083 15L35.1643 6.996H36.7603L39.1843 13.476L41.6083 6.996H43.2043L40.0603 15H38.3083ZM44.0786 15V6.996H49.5626V8.232H45.4826V10.308H49.4786V11.544H45.4826V13.764H49.5626V15H44.0786Z"
      fill="#00B7B1"
    />
  </svg>
);

export default Live;
